function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8,29.686a1.554,1.554,0,0,0,0-1.976l-2.663-2.663L46.284,13.537a1.347,1.347,0,0,0-1.89,0h0a1.307,1.307,0,0,0,0,1.976L56.85,27.71a1.456,1.456,0,0,1,0,1.976L44.137,42.314a1.456,1.456,0,0,0,0,1.976h0a1.436,1.436,0,0,0,1.89,0L57.795,32.607l.086-.086Z",
  transform: "translate(-6.157 -4.002)",
  fill: "#046eab"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.342,29.686a1.554,1.554,0,0,1,0-1.976L3,25.047,14.859,13.537a1.347,1.347,0,0,1,1.89,0h0a1.307,1.307,0,0,1,0,1.976l-12.2,12.2a1.456,1.456,0,0,0,0,1.976L17.007,42.314a1.456,1.456,0,0,1,0,1.976h0a1.436,1.436,0,0,1-1.89,0L3.091,32.779,3,32.693Z",
  transform: "translate(0.013 -4.002)",
  fill: "#046eab"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M43.371,2.5H26.62L17.6,27.927l11,.086-8.59,25.169L43.714,19.594H32.2Z",
  transform: "translate(-2.47 -2.5)",
  fill: "#1590cf"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6,19.594,43.765,2.5H35L25.726,23.632l11,.086L20.4,53.182,44.109,19.594Z",
  transform: "translate(-2.865 -2.5)",
  fill: "#046eab"
});

var SvgFunctionApps = function SvgFunctionApps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50.682,
    viewBox: "0 0 55 50.682",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFunctionApps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/function_apps.294c137a.svg";
export { ForwardRef as ReactComponent };